import { customScrollbar } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 16px;
	max-height: 500px;
	height: fit-content;
	padding-right: 10px;
`;

export const ActivityCheckSection = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: start;
	gap: 16px;
`;

export const PanelsContainer = styled.div`
	display: grid;
	gap: 56px;
	max-height: 464px;
	overflow-y: auto;
	padding-right: 10px;

	${customScrollbar};
`;

export const ElementsForm = styled.div<{ $disabled?: boolean }>`
	display: grid;
	gap: 32px;
`;

export const DateSection = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;

	#day-picker-container-end-date {
		.rdp:last-child {
			right: 0;
			left: unset;
		}
	}
`;

export const ExamsForm = styled.div`
	display: grid;
	gap: 24px;
	margin-bottom: 50px;
`;

export const ExamsSection = styled.div`
	display: grid;
	gap: 8px;
`;

export const ExamItemSection = styled.div`
	display: grid;
	grid-template-columns: 24px 1fr;
	padding: 8px;
	align-items: center;
	gap: 10px;

	& > button {
		width: 24px;
		height: 24px;
		padding: 4px;
	}
`;

export const ExamInputSelector = styled.div`
	display: grid;
	grid-template-columns: 1fr 40px;
	gap: 16px;
	align-items: center;

	.right-side-panel-autocomplete-input {
		div:nth-child(2) {
			top: 0;
		}
	}

	& > button {
		height: calc(100% - 4px);
	}
`;

export const Empty = styled.div`
	display: grid;
	place-items: center;
	max-height: 500px;
	height: 500px;
`;

export const InputContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const ActivityMessageContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
`;
